import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Agenda } from "../../common/models/agenda";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { AthleteGuest } from "../../common/models/athlete-guest";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { Athlete } from "../../common/models/athlete";
import { Coach } from "../../common/models/coach";
import { Guest } from "../../common/models/guest";


export class AgendaRights {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
    private _itemRightsList: AgendaItemRightsList | null = null;
    private _screenRightsList: AgendaScreenRightList | null = null;
    private _paramsItem: AgendaItemRightsParams | null = null;
    private _paramsScreen: AgendaScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    public evaluateItemRight(params: AgendaItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le agenda, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cet agenda (agenda.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

      const rights = this._paramsItem.agenda.rights;
      if (!this._itemRightsList || rights == undefined) return;

      this._itemRightsList.view = rights.includes('view');
      this._itemRightsList.edit = rights.includes('edit');
      this._itemRightsList.delete = rights.includes('delete');

      return;

        // const agenda = this._paramsItem.agenda;
        // const agendaAthletes = this._utils.findManyIn([agenda.athleteId], this._paramsItem.athletes, 'id');
        // const agendaAthUserIds = this._utils.getKeyValues(agendaAthletes, 'userId');
        // const athMemberships = this._utils.findManyIn(agendaAthUserIds, this._paramsItem.athleteMemberships, 'userId');
        // const athOrgIds = this._utils.getKeyValues(athMemberships, 'organizationId');
        // const links = this._utils.findManyIn([agenda.athleteId], this._paramsItem.athleteCoachRelations, 'athleteId');
        // const coachIds = this._utils.getKeyValues(links, 'coachId');
        // const me = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.coaches, 'userId');
        //
        // switch (this._bestOfItemRight) {
        // case OrganizationRole.ID_ADMIN:
        //     // this._paramsItem.user est un admin
        //     // tous les agendas
        //     this._itemRightsList.view = true;
        //     this._itemRightsList.edit = true;
        //     this._itemRightsList.delete = true;
        //     break;
        //
        // case OrganizationRole.ID_SUPERCOACH:
        //     // this._paramsItem.user est un supercoach
        //     // tous les agendas de son organisation
        //
        //     if (athOrgIds.indexOf(this._paramsItem.organizationId) > -1) {
        //         this._itemRightsList.view = true;
        //         this._itemRightsList.edit = true;
        //         this._itemRightsList.delete = true;
        //     }
        //     break;
        //
        // case OrganizationRole.ID_COACH:
        //     // this._paramsItem.user est un coach
        //     // tous les agendas ayant une relation avec lui
        //     if (coachIds.indexOf(me.id) > -1) {
        //         this._itemRightsList.view = true;
        //         this._itemRightsList.edit = true;
        //         this._itemRightsList.delete = true;
        //     }
        //     break;
        //
        // case OrganizationRole.ID_ATHLETE:
        //     // this._paramsItem.user est un athlète
        //     // tous ses agendas
        //     const athlete = this._utils.findIn(agenda.athleteId, this._paramsItem.athletes, 'id');
        //     if (agenda.athleteId === athlete.id) {
        //         this._itemRightsList.view = true;
        //     }
        //     break;
        //
        // case OrganizationRole.ID_GUEST:
        //     // this._paramsItem.user est un invité
        //     // idem que le coach mais en lecture seule
        //     const guestlinks = this._utils.findManyIn([agenda.athleteId], this._paramsItem.athleteGuestRelations, 'athleteId');
        //     const guestIds = this._utils.getKeyValues(guestlinks, 'guestId');
        //     const guest = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.guests, 'userId');
        //
        //     if (guestIds.indexOf(guest.id) > -1) {
        //         this._itemRightsList.view = true;
        //     }
        //     break;
        //
        // default:
        //     // rien
        // }
    }

    public evaluateScreenRights(params: AgendaScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if (!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): AgendaItemRightsList {
        if (!this._itemRightsList) throw new Error('Item rights not evaluated');
        return this._itemRightsList;
    }

    public getScreenRightsList(): AgendaScreenRightList {
        if (!this._screenRightsList) throw new Error('Screen rights not evaluated');
        return this._screenRightsList;
    }

    public getItemParams(): AgendaItemRightsParams {
        if (!this._paramsItem) throw new Error('Item params not set');
        return this._paramsItem;
    }

    public getScreenParams(): AgendaScreenRightsParams {
        if (!this._paramsScreen) throw new Error('Screen params not set');
        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

      this._itemRightsList = {
          view: false,
          edit: false,
          delete: false,
        };

      this._screenRightsList = {
          list: false,
          add: false,
          edit: false,
          delete: false,
        };
        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface AgendaItemRightsList {
    view: boolean;
    edit: boolean;
    delete: boolean;
}

export interface AgendaScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface AgendaItemRightsParams {
    user: User;
    organizationId: number;
    agenda: Agenda;
    rolesIds: number[];
    athleteCoachRelations: AthleteCoach[];
    athleteGuestRelations: AthleteGuest[];
    athleteMemberships: OrganizationMembership[];
    athletes: Athlete[];
    coaches: Coach[];
    guests: Guest[];
}

export interface AgendaScreenRightsParams {
    rolesIds: number[];
}
